var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.249 36.288C30.249 49.702 41.123 60.573 54.534 60.573V12C41.122 12.001 30.249 22.875 30.249 36.288Z",
    fill: "#CFBCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8202 36.287C78.8202 22.874 67.9472 12 54.5342 12V60.573C60.0002 60.573 65.0422 58.768 69.1012 55.721L78.8212 64L74.1612 50.588C77.0882 46.576 78.8202 41.636 78.8202 36.287Z",
    fill: "#7551D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.572 21.5391C7.07699 21.5391 1 27.6121 1 35.1111V38.2521C1 45.3361 6.431 51.1451 13.353 51.7641L4.88998 67.6741L27.846 51.8241H32.491V21.5391H14.572Z",
    fill: "#CFBCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9932 51.3231V22.0391H52.3141C59.5321 22.0391 65.3852 27.8883 65.3852 35.1101V38.2511C65.3852 45.469 59.532 51.3231 52.3141 51.3231H32.9932Z",
    fill: "#7551D0",
    stroke: "#CFBCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7998 36.7202C21.7998 38.0432 20.7269 39.1172 19.4019 39.1172C18.0789 39.1172 17.0059 38.0432 17.0059 36.7202C17.0059 35.3962 18.0789 34.3242 19.4019 34.3242C20.7269 34.3232 21.7998 35.3952 21.7998 36.7202Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8389 36.7202C35.8389 38.0432 34.7669 39.1172 33.4419 39.1172C32.1189 39.1172 31.0459 38.0432 31.0459 36.7202C31.0459 35.3962 32.1189 34.3242 33.4419 34.3242C34.7669 34.3232 35.8389 35.3952 35.8389 36.7202Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8789 36.7202C49.8789 38.0432 48.8059 39.1172 47.4819 39.1172C46.1579 39.1172 45.0859 38.0432 45.0859 36.7202C45.0859 35.3962 46.1579 34.3242 47.4819 34.3242C48.8069 34.3232 49.8789 35.3952 49.8789 36.7202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialCampaign);
export default __webpack_public_path__ + "static/media/social-campaign.bd46c19cfd1b5773d9b3bf2e661e75ce.svg";
export { ForwardRef as ReactComponent };